import { Link, useMatchRoute } from "@tanstack/react-router";
import {
  Users,
  Bot,
  Shield,
  Bell,
  LayoutTemplate,
  FileText,
} from "lucide-react";
import { cn } from "@/lib/utils";

const navItems = [
  { to: "/dashboard/admin/users", label: "Users", icon: Users },
  { to: "/dashboard/admin/custom-bots", label: "Custom Bots", icon: Bot },
  {
    to: "/dashboard/admin/templates",
    label: "Templates",
    icon: LayoutTemplate,
  },
  {
    to: "/dashboard/admin/official-presets",
    label: "Official Presets",
    icon: FileText,
  },
  {
    to: "/dashboard/admin/notifications",
    label: "Notifications",
    icon: Bell,
  },
] as const;

export function AdminSidebar() {
  const matchRoute = useMatchRoute();

  return (
    <>
      {/* Mobile: horizontal tab bar */}
      <nav className="flex gap-1 overflow-x-auto border-b pb-2 md:hidden">
        {navItems.map((item) => {
          const isActive = matchRoute({ to: item.to, fuzzy: true });
          return (
            <Link
              key={item.to}
              to={item.to}
              className={cn(
                "flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors",
                isActive
                  ? "bg-rose-500/10 text-rose-500"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground"
              )}
            >
              <item.icon className="size-3.5" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* Desktop: vertical sidebar */}
      <aside className="hidden w-56 shrink-0 md:block">
        <div className="sticky top-20 space-y-1">
          <div className="mb-4 flex items-center gap-2 px-3">
            <div className="flex size-8 items-center justify-center rounded-lg bg-gradient-to-br from-rose-500/10 to-red-500/10">
              <Shield className="size-4 text-rose-500" />
            </div>
            <span className="text-sm font-semibold">Admin</span>
          </div>
          {navItems.map((item) => {
            const isActive = matchRoute({ to: item.to, fuzzy: true });
            return (
              <Link
                key={item.to}
                to={item.to}
                className={cn(
                  "flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors",
                  isActive
                    ? "bg-rose-500/10 font-medium text-rose-500"
                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                )}
              >
                <item.icon className="size-4" />
                {item.label}
              </Link>
            );
          })}
        </div>
      </aside>
    </>
  );
}
